module.exports = __webpack_public_path__ + "static/media/app-bar-account.3d368986.svg";